import type { ButtonHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

export interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
  /** A CSS colour for a small leading dot. */
  dot?: string;
}

/** A pill for picking among short options; it sits on a card, so the idle pill is sunken. */
export function Chip({ selected = false, dot, className, children, type = 'button', ...rest }: ChipProps) {
  return (
    <button
      type={type}
      aria-pressed={selected}
      className={cn(
        'inline-flex items-center gap-1.5 min-h-9 px-3 py-1.5 rounded-full text-sm leading-tight text-center font-medium select-none',
        'transition-[transform,background-color,color] duration-150 ease-smooth active:scale-[0.97]',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        selected ? 'bg-ink text-ink-on' : 'bg-surface-2 text-fg',
        className,
      )}
      {...rest}
    >
      {dot && <span aria-hidden className="w-2 h-2 rounded-full" style={{ backgroundColor: dot }} />}
      {children}
    </button>
  );
}
